import { customEvent } from '@/lib';
import AppRoutes from './routes';

export interface FooterLink {
	title: string;
	url: string;
	onClick?: () => void;
}

interface Links {
	company: FooterLink[];
	learn: FooterLink[];
}

export const footerLinks: Links = {
	company: [
		{ title: 'About Us', url: AppRoutes.LANDING_ABOUT_US },
		{
			title: 'Contact Us',
			url: AppRoutes.LANDING_CONTACT_US,
			onClick: () => {
				customEvent({
					action: 'contact_us_click',
					category: 'landing',
					label: 'Contact Us',
					value: 'Contact Us',
				});
			},
		},
	],
	learn: [
		{
			title: 'FAQs',
			url: '/faqs',
			onClick: () => {
				customEvent({
					action: 'faq_click',
					category: 'landing',
					label: 'View all FAQs',
					value: 'View all FAQs',
				});
			},
		},
		{ title: 'Privacy Policy', url: '/privacy-policy' },
		{ title: 'Terms of Use', url: '/terms-of-use' },
	],
};
